/* eslint-disable */
import {Service} from 'components/Shared/server';
import {Faq} from 'models/Faq';


export const routeGetCategoryFaq = (webCatalog: string, page: number) => `/api/faq/category?webCatalog=${encodeURIComponent(webCatalog)}&page=${page}`;
export function getCategoryFaq(webCatalog: string, page: number): Promise<Faq[]> {
  return Service.get<Faq[]>({
    url: routeGetCategoryFaq(webCatalog, page)
  });
}

export const routeGetProductFaq = (productId: string, page: number) => `/api/faq/product?productId=${encodeURIComponent(productId)}&page=${page}`;
export function getProductFaq(productId: string, page: number): Promise<Faq[]> {
  return Service.get<Faq[]>({
    url: routeGetProductFaq(productId, page)
  });
}
